import { Link } from "react-router"
import { useQueryClient } from "@tanstack/react-query"
import SPB_CARD_IMG from "../../images/spb-wizard-card.svg"

import CheckmarkListItem from "../../components/CheckmarkListItem"
import {
  useAccountId,
  useAccountUrlPrefix,
  useGetInsuranceWizard,
} from "../../hooks"
import { LiabilityInsuranceTypes } from "@/types/liabilityInsuranceWizard"

const LiabilityInsuranceCard = () => {
  const queryClient = useQueryClient()
  const accountId = useAccountId()
  const accountUrlPrefix = useAccountUrlPrefix()

  const { data: insuranceWizardData, isLoading: isInsuranceDataLoading } =
    useGetInsuranceWizard<LiabilityInsuranceTypes, Error>(
      queryClient,
      accountId
    )

  if (!insuranceWizardData || isInsuranceDataLoading) {
    return null
  }

  const completed = insuranceWizardData.completed

  return (
    <div className="bg-cloud-50 flex gap-4 border-2 border-[#ECA674] rounded-sm p-4">
      <div className="flex items-center shrink-0">
        <img
          src={SPB_CARD_IMG}
          alt="spb"
          width={84}
          height={138}
          data-testid="liability-insurance-card-img"
        />
      </div>

      <div className="w-full">
        <h3
          className="font-bold leading-[130%] font-body tracking-[0.32px]"
          data-testid="liability-insurance-card-heading"
        >
          Liability Insurance <span className="text-autumn italic">[New]</span>
        </h3>

        <p
          className="font-body leading-[130%] tracking-[0.32px] mt-2"
          data-testid="liability-insurance-card-description"
        >
          Essential protection for all landonwers.
        </p>

        <ul className="w-full grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-x-10 gap-y-2 mt-4">
          <CheckmarkListItem>Comprehensive protection</CheckmarkListItem>

          <CheckmarkListItem>$2M aggregate policy limit</CheckmarkListItem>

          <CheckmarkListItem>Covers injuries to visitors</CheckmarkListItem>

          <CheckmarkListItem>
            Covers property damage to visitors
          </CheckmarkListItem>

          <CheckmarkListItem>
            Exclusive pricing for NCX members
          </CheckmarkListItem>
        </ul>

        <Link
          to={`${accountUrlPrefix}/liability-insurance?step=${
            completed ? 5 : 1
          }`}
          className="liability-insurance-btn btn2 btn2-primary font-bold px-6 py-[11px] mt-4"
          data-testid="liability-insurance-card-link"
        >
          {completed ? "View Policy Details" : "Get Instant Quote"}
        </Link>
      </div>
    </div>
  )
}

export default LiabilityInsuranceCard
